export const style = {
  typograpyStatus: {
    sx: {
      color: 'action.active',
    },
  },
  typograpyDesc: {
    sx: {
      color: 'action.active',
    },
  },
  box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      color: 'action.active',
      gap: 1,
      pt: 1,
    },
  },
} as const;
